import { Row, TitleSection } from "components/styles";
import PageManager from "components/PageManager/PageManager";
import { getFormattedCaption } from "components/PageManager/utils";
import useResourcesUniversitySpacesContext from "../utils/context/useResourcesUniversitySpacesContext";

const Header = ({
    appliedFilters, 
    paginator
}) => {
    const { spaceList } = useResourcesUniversitySpacesContext();
    const getCaption = () => {
        return `${getFormattedCaption({
            ...paginator.data,
            currentPage: appliedFilters.value.page
        })} Espacios `;
    }
    return (
        <Row width="100%">
            <TitleSection>Filtros de búsqueda</TitleSection>
            <PageManager 
                caption={getCaption()}
                isFreeCaption
                noPages={spaceList.isEmpty()}
                dataPaginator={{
                    ...paginator.data,
                    setCurrentPage: page => {
                        paginator.movePage(page);
                        spaceList.triggerFilling();
                    }
                }}/>
        </Row>
    );
}

export default Header;